import React from "react";
import { ChevronRight, Home } from "lucide-react";
import { FileNode } from "./types";

export interface BreadcrumbsProps {
  path: FileNode[];
  onNavigate: (node: FileNode | null) => void;
  className?: string;
}

export function Breadcrumbs({
  path,
  onNavigate,
  className = "",
}: BreadcrumbsProps) {
  return (
    <div
      data-testid="breadcrumbs"
      className={`flex items-center gap-1 text-sm ${className}`}
    >
      {/* Root/Home */}
      <button
        onClick={() => onNavigate(null)}
        className="flex items-center gap-1 px-2 py-1 rounded-md text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        title="Root folder"
      >
        <Home className="w-4 h-4" />
      </button>

      {path.map((node) => (
        <React.Fragment key={node.id}>
          <ChevronRight className="w-4 h-4 text-gray-400 dark:text-gray-600 flex-shrink-0" />
          <button
            onClick={() => onNavigate(node)}
            className="px-2 py-1 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors truncate max-w-[200px]"
            title={node.name}
          >
            {node.name}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
